import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { UITab, UITabs } from '@gohighlevel/ghl-ui';
export default /*#__PURE__*/ _defineComponent({
    __name: 'MonthlyYearlySwitch',
    props: {
        cycle: {
            type: String,
            required: true,
        },
        monthlyLabel: {
            type: String,
            required: true,
        },
        annualLabel: {
            type: String,
            required: true,
        },
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UITabs), {
                animated: "",
                value: __props.cycle,
                type: "segment",
                "onUpdate:value": _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('update:cycle', $event)))
            }, {
                default: _withCtx(() => [
                    _createVNode(_unref(UITab), { name: "monthly" }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(__props.monthlyLabel), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createVNode(_unref(UITab), { name: "annual" }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(__props.annualLabel), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["value"]));
        };
    }
});
